module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/gmat/sections/apps/assets/flashcard_app-8ac2f03e1967b1c4a7c86b97b6ae1052.png";